import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import CommentIcon from '@material-ui/icons/Comment';
import AttachmentIcon from '@material-ui/icons/AttachFile';
import { CardPageLayout } from "component-lib/CardPageLayout";
import DrawerAttachments from "modals/DrawerAttachments/DrawerAttachments";
import { DrawerNotes } from "modals/DrawerNotes/DrawerNotes";
import { SimpleInfoModal } from 'modals/SimpleInfoModal';
import {
  hedgeDetailGetHedge, hedgeDetailGetDealMetrics, hedgeDetailGetDealProperties, hedgeDetailGetNewHedge
  , hedgeGetAttachments
  , hedgePutAttachment
  , hedgePostAttachment
  , hedgeDeleteAttachment
  , hedgeGetNotes
  , hedgePutNote
  , hedgePostNote
  , hedgeDeleteNote
  , deleteHedge
} from './hedgeDetail.store';
import { mapCompanySelector, mapGuestPermissions } from "store/state/auth";
import { PrimaryButton, ButtonSizeOptions, SecondaryButton, DEAL_METRICS, COMPANY_LEVELS, LabeledButtonWithCountMultiple, GUEST_PERMISSIONS } from '@loanbossinc/component-library';
import { HedgeFinancials } from './hedge-financials/hedge-financials';
import { HedgeGeneralInformation } from "./hedge-general-information/hedge-general-information";
import { HedgeRatings } from "./hedge-ratings/hedge-ratings";
import { GenericHeroCard } from "component-lib/";
import pagesHelper from 'utils/pagesHelper';
import guestPermissionHelper from 'utils/guestPermissionHelper';

const dealMetrics = [
  DEAL_METRICS.CLOSING_DATE
  , DEAL_METRICS.PURCHASE_PRICE
  , DEAL_METRICS.SQUARE_FEET
];

const StyledBodyWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;

const StyledTitleSection = styled.div`
  && {
    display: flex;
    flex-direction: row;
    .title {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      align-items: center;
      text-align: center;
  
      color: #000000;
    }
  }
`;
const StyledLabeledButtonWithCountMultiple = styled(LabeledButtonWithCountMultiple)`
  margin-top: 2em;
`;
const HEDGE_MODAL_ATTACHMENTS = 'HEDGE_MODAL_ATTACHMENTS';
const HEDGE_MODAL_NOTES = 'HEDGE_MODAL_NOTES';
const SIMPLE_INFO_MODAL = 'SIMPLE_INFO_MODAL';

class HedgeDetail extends Component {
  state = {
    isAllExpanded: false
    , isAllCollapsed: false
    , openModal: { name: null, data: null }
    , heroCardButtons: []
    , confirmationModal: {
      title: "",
      onClose: () => { },
      onAccept: () => { },
      content: "",
    }
  }

  componentDidMount() {
    const { hedgeId, dealId } = this.props.match.params;
    if (hedgeId == 'new') {
      this.props.hedgeDetailGetNewHedge({ hedgeId, dealId });
    } else {
      this.props.hedgeDetailGetHedge({ hedgeId });
      this.props.hedgeDetailGetDealProperties({ hedgeId });
      this.props.hedgeGetNotes({ hedgeId });
      this.props.hedgeGetAttachments({ modelName: 'hedge', modelId: hedgeId });
    }
  }
  getNotificationOptions = () => {
    const { notes, attachments, company, authentication } = this.props;
    const isStarter = company.companyLevelId !== COMPANY_LEVELS.PROFESSIONAL
      && company.companyLevelId !== COMPANY_LEVELS.ENTERPRISE
      && company.companyLevelId !== COMPANY_LEVELS.SECONDARY_SPONSOR;

    let { notesLength, attachmentsLength } = pagesHelper.getNotesAttachmentCounts(notes, attachments, authentication);
    const buttonList = [{
      label: 'notes'
      , count: notesLength
      , onClick: () => this.openModal(HEDGE_MODAL_NOTES)
      , icon: <CommentIcon />
      , buttonWidth: "179px"
    }, {
      label: 'ATTACHMENTS'
      , count: attachmentsLength
      , onClick: () => this.openModal(HEDGE_MODAL_ATTACHMENTS)
      , icon: <AttachmentIcon />
      , buttonWidth: "179px"
    }];

    isStarter ? buttonList.splice(2, 1) : buttonList.splice(3, 1);
    return buttonList;
  }

  openModal = (name, data = null) => this.setState({ openModal: { name, data } });
  closeModal = () => this.setState({ openModal: { name: null, data: null } });
  isModalOpen = (modalName) => {
    const { openModal } = this.state;
    return openModal.name === modalName;
  }

  componentDidUpdate(prevProps) {
    const { hedgeId } = this.props.match.params;
    const { hedge } = this.props;
    if (hedgeId === 'new' && hedge && hedge.id) { this.props.history.replace(`/hedges/${hedge.id}`); }
    if (this.props !== prevProps) { this.setHeroCardButtons(); }
  }

  setHeroCardButtons = () => {
    const { hedge } = this.props;

    if (hedge) {
      let buttons = [];

      const cashflowButton = this.cashflowButton();
      if (cashflowButton) buttons.push(cashflowButton);
      const deleteButton = this.deleteButton();
      if (deleteButton) buttons.push(deleteButton);

      this.setState({ heroCardButtons: buttons });
    }
  };

  cashflowButton = () => {
    return { label: "Hedge Cashflows", onClick: () => this.toLoanCashflows() };
  }
  toLoanCashflows = () => {
    const { hedge, flags: { us1304BrokerFrontendUrlEnvironmentVariable: brokerFrontendURL } } = this.props;
    window.location.assign(`${brokerFrontendURL}/cashflows/${hedge.dealId}/hedges/${hedge.id}`);
  }

  deleteButton = () => {
    const { authentication } = this.props;
    const { hedgeId } = this.props.match.params;
    if (!authentication || authentication.isGuest || !authentication.isSystemAdmin) return null;

    return {
      label: "Delete Hedge",
      onClick: () => {
        this.openConfirmationDialog("Delete Hedge", this.closeModal, () => {
          if (hedgeId) {
            this.props.deleteHedge({ hedgeId: hedgeId, callback: () => this.props.history.push(`/deal/${this.props.hedge.dealId}`) });
          }
          this.closeModal();
        },
          (<><p>Are you sure that you want to delete this hedge?</p> <p>This action cannot be undone.</p></>)
        );
      }
    };
  }

  openConfirmationDialog = (title, onClose, onAccept, content) => {
    this.setState({ confirmationModal: { title, onClose, onAccept, content } });
    this.openModal(SIMPLE_INFO_MODAL);
  }

  onBackButtonClick = () => {
    this.props.history.push(`/deal/${this.props.hedge.dealId}`);
  }

  renderHeroCard = () => {
    const title = `${this.props.hedge.hedgeProvider ? this.props.hedge.hedgeProvider.name : "No Provider Selected"} - ${this.props.hedge.hedgeType ? this.props.hedge.hedgeType.value : "No Type Selected"}`;
    return (
      <div>
        <GenericHeroCard {...{ ...this.props, deal: this.props.dealProperties, buttons: this.state.heroCardButtons, title: title, backLabel: "Deal Summary", onBackButtonClick: this.onBackButtonClick, displayMetrics: false }} />
        <StyledLabeledButtonWithCountMultiple options={this.getNotificationOptions()} />
      </div>
    );
  }
  renderBody = () => {
    const { hedge, history, authentication, guestPermission } = this.props;
    const { hedgeId } = this.props.match.params;
    const { isAllExpanded, isAllCollapsed } = this.state;
    const groupProps = {
      data: hedge
      , hedgeId
      , history
      , shouldExpandAll: isAllExpanded
      , onToggleExpandAll: () => this.setState({ isAllExpanded: false })
      , shouldCollapseAll: isAllCollapsed
      , onToggleCollapseAll: () => this.setState({ isAllCollapsed: false })
      , enableEditButton: guestPermissionHelper.enableEditButton(authentication, guestPermission, GUEST_PERMISSIONS.EDIT)
    };

    return (
      <StyledBodyWrapper>
        <StyledTitleSection>
          <div className="title">Hedge Details</div>
          <SecondaryButton
            style={{ marginLeft: 'auto' }}
            label="Collapse All"
            onClick={() => this.setState({ isAllCollapsed: true })}
            size={ButtonSizeOptions.smFluid}
          />
          <PrimaryButton
            style={{ marginLeft: 24 }}
            label="Expand All"
            onClick={() => this.setState({ isAllExpanded: true })}
            size={ButtonSizeOptions.smFluid}
          />
        </StyledTitleSection>

        <HedgeFinancials {...groupProps} />
        <HedgeGeneralInformation {...groupProps} />
        <HedgeRatings {...groupProps} />
      </StyledBodyWrapper>
    );
  }

  render() {
    const { isLoading } = this.props;
    const { hedgeId, dealId } = this.props.match.params;
    if (!this.props.hedge || !this.props.hedge.deal) return null;

    return (
      <>
        <CardPageLayout {...this.props}
          isReversed
          bannerImageUrl={this.props.hedge && this.props.hedge.deal && this.props.hedge.deal.imageLarge}
          cardComponent={this.renderHeroCard()}
          bodyComponent={this.renderBody()}
        />


        <DrawerAttachments
          isOpen={this.isModalOpen(HEDGE_MODAL_ATTACHMENTS)}
          files={this.props.attachments}
          authentication={this.props.authentication}
          closeDrawer={this.closeModal}
          isLoading={isLoading}
          onAdd={(file) => this.props.hedgePostAttachment({ file, hedgeId })}
          onUpdate={(file) => this.props.hedgePutAttachment({ file, hedgeId })}
          onRemove={(file) => this.props.hedgeDeleteAttachment({ fileId: file.id, hedgeId })}
        />

        <DrawerNotes
          isOpen={this.isModalOpen(HEDGE_MODAL_NOTES)}
          notes={this.props.notes}
          authentication={this.props.authentication}
          closeDrawer={this.closeModal}
          onAdd={(note) => this.props.hedgePostNote({ note, hedgeId })}
          onUpdate={(note) => this.props.hedgePutNote({ note, hedgeId })}
          onRemove={(note) => this.props.hedgeDeleteNote({ noteId: note.id, hedgeId })}
          type="hedge"
        />

        <SimpleInfoModal
          title={this.state.confirmationModal.title}
          isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
          onClose={() => this.state.confirmationModal.onClose()}
          onAccept={() => this.state.confirmationModal.onAccept()}
          content={this.state.confirmationModal.content}
        />
      </>
    );
  }
}

const mapStateToProps = ({ newHedgeDetail, loading, authentication }) => ({
  ...newHedgeDetail
  , guestPermission: mapGuestPermissions(authentication, newHedgeDetail.guestPermission)
  , company: mapCompanySelector(authentication)
  , authentication
  , isLoading: loading.hedge_file_upload
});

export default compose(
  withRouter,
  withLDConsumer()
  , connect(mapStateToProps, {
    hedgeDetailGetHedge
    , hedgeDetailGetDealMetrics
    , hedgeDetailGetDealProperties
    , hedgeDetailGetNewHedge

    , hedgeGetAttachments
    , hedgePutAttachment
    , hedgePostAttachment
    , hedgeDeleteAttachment

    , hedgeGetNotes
    , hedgePutNote
    , hedgePostNote
    , hedgeDeleteNote
    , deleteHedge
  })
)(HedgeDetail);
